import { FC } from 'react';
import { $fm } from '@/Intl';
import { useLocation } from 'react-router';
import { useProduct } from '@/store';
import './OperateTips.less';

const getTxt = (path: string | undefined, product: Product) => {
  switch (path) {
    case '/settings': {
      return (
        <>
          <p>{$fm('CONFIG_SET_TIP')}</p>
        </>
      );
    }
    case '/phonebook': {
      return (
        <>
          <p>{$fm('CONTACT_SET_TIP')}</p>
          <p>{$fm('CONTACT_SET_TIP2')}</p>
        </>
      );
    }
    case '/background': {
      return (
        <>
          <p>{$fm('BACKGROUND_SET_TIP')}</p>
          <p>{$fm('BACKGROUND_SET_TIP2')}</p>
        </>
      );
    }
    case '/layout': {
      return (
        <>
          <h3>{$fm('LAYOUT_TIP_TITLE1')}</h3>
          <p>{$fm('LAYOUT_TIP1')}</p>
          <h3>{$fm('LAYOUT_TIP_TITLE2')}</h3>
          <p>{$fm('LAYOUT_TIP2')}</p>
          <h3>{$fm('LAYOUT_TIP_TITLE3')}</h3>
          <p>{$fm('LAYOUT_TIP3')}</p>
          <h3>{$fm('LAYOUT_TIP_TITLE4')}</h3>
          <p>{$fm('LAYOUT_TIP4')}</p>
          <p>{$fm('LAYOUT_TIP42')}</p>
          <h3>{$fm('LAYOUT_TIP_TITLE5')}</h3>
          <p>{$fm('LAYOUT_TIP5')}</p>
          <h3>{$fm('LAYOUT_TIP_TITLE6')}</h3>
          <p>{$fm('LAYOUT_TIP6')}</p>
          <p>{$fm('LAYOUT_TIP62')}</p>
          <p>{$fm('LAYOUT_TIP63')}</p>
        </>
      );
    }
    case '/callset': {
      return (
        <>
          <h3>{$fm('CALL_TIP_TITLE1')}</h3>
          <p>{$fm(product === 'gxv3350' ? 'CALL_TIP1_3350' : 'CALL_TIP1')}</p>
          <h3>{$fm('CALL_TIP_TITLE2')}</h3>
          <p>{$fm('CALL_TIP2')}</p>
          <p>{$fm(product === 'gxv3350' ? 'CALL_TIP4_3350' : 'CALL_TIP4')}</p>
        </>
      );
    }
    case '/screensaver': {
      return (
        <>
          <p>{$fm('SCREENSETTIP')}</p>
        </>
      );
    }
    case '/language': {
      return (
        <>
          <p>{$fm('LANGUAGE_SET_TIP')}</p>
        </>
      );
    }
    case '/taskbar': {
      return (
        <>
          <p>{$fm('TASKBAR_SET_TIP')}</p>
          <p>{$fm('TASKBAR_SET_TIP2')}</p>
          <p>{$fm('TASKBAR_SET_TIP3')}</p>
        </>
      );
    }
    case '/fitscreen': {
      return (
        <>
          <p>{$fm('ADJUST_SCREEN_TIP')}</p>
        </>
      );
    }
    default: {
      return <></>;
    }
  }
};

const OperateTips: FC = () => {
  const { pathname } = useLocation();
  const [product] = useProduct();
  const p = pathname.match(/\/[^/]*$/)?.[0];
  return (
    <div className='operate-tips'>
      <h3>{$fm('INSTRUCTIONS')}</h3>
      {getTxt(p, product)}
    </div>
  );
};

export default OperateTips;
